module.exports = __webpack_public_path__ + "img/honour.f808addc.png";